import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/core/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule, MatButtonModule, MatSelectModule, MatCardModule, MatAutocompleteModule, MatIconModule, MatProgressBarModule } from '@angular/material';
import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { UserProcedureManagementComponent } from './user-procedure-management/user-procedure-management.component';
import { UserEditProcedureComponent } from './user-procedure-management/user-edit-procedure/user-edit-procedure.component';
import { UserAddProcedureComponent } from './user-procedure-management/user-add-procedure/user-add-procedure.component';
import { UserViewProcedureComponent } from './user-procedure-management/user-view-procedure/user-view-procedure.component';

@NgModule({
  declarations: [UserProcedureManagementComponent, UserEditProcedureComponent, UserAddProcedureComponent, UserViewProcedureComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    NgZorroAntdModule
  ],
})
export class UserConfigModule { }
